import { render, staticRenderFns } from "./SesiAreaJoinCampaign.vue?vue&type=template&id=1c1821ab&scoped=true&"
import script from "./SesiAreaJoinCampaign.vue?vue&type=script&lang=js&"
export * from "./SesiAreaJoinCampaign.vue?vue&type=script&lang=js&"
import style0 from "./SesiAreaJoinCampaign.vue?vue&type=style&index=0&id=1c1821ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1821ab",
  null
  
)

export default component.exports